import { render, staticRenderFns } from "./ColSetting.vue?vue&type=template&id=d2991344&scoped=true"
import script from "./ColSetting.vue?vue&type=script&lang=js"
export * from "./ColSetting.vue?vue&type=script&lang=js"
import style0 from "./ColSetting.vue?vue&type=style&index=0&id=d2991344&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2991344",
  null
  
)

export default component.exports